/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import * as React from "react";

import { useClassName } from "./FlexItem.mappers";
import { FlexItemProps } from "./FlexItemProps";

/**
 * Renders the FlexItem component.
 * @param props The properties.
 * @returns The FlexItem component.
 */
export const FlexItem = React.forwardRef<HTMLDivElement, FlexItemProps>((props, ref) => {
    const { children, ...rest } = props;
    const className = useClassName(props);

    return (
        <div ref={ref} {...rest} className={className}>
            {children}
        </div>
    );
});

// Ensure ESLint 'react/display-name' rule passes for forwardRef components
FlexItem.displayName = "FlexItem";
